import React from "react";
import PropTypes from "prop-types";
import LossToActionOverview from "../../LossToActionOverview";
const InTransitRecoveryGlobalOverviewTable = ({
  data,
  columns,
  paginationData = {},
  sortingData = {},
  handlePageChange = null,
  isLoading = false,
}) => {
  const scrollableColumnsArray = [
    "Shipment Details",
    "Order Loss Mitigation",
    "% Order Loss Mitigation",
    "Overall loss Mitigation",
    "% Overall loss Mitigation",
    "Physical MSTN Loss Mitigation",
    "% Physical MSTN loss Mitigation",
    "Weighted Score",
    "Day wise Value Mitigation",
    "Order Loss Details",
  ];
  return (
    <LossToActionOverview
      data={data}
      columns={columns}
      paginationData={paginationData}
      sortingData={sortingData}
      handlePageChange={handlePageChange}
      isLoading={isLoading}
      scrollableColumnsArray={scrollableColumnsArray}
      totalColumnName="Shipment Number"
      fixedColumnName="Order details"
      tableType="InTransit Recovery"
    />
  );
};

InTransitRecoveryGlobalOverviewTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  paginationData: PropTypes.shape({
    page: PropTypes.number,
    rowsPerPage: PropTypes.number,
    totalRecords: PropTypes.number,
  }),
  sortingData: PropTypes.shape({
    sortBy: PropTypes.string,
    sortOrder: PropTypes.string,
  }),
  handlePageChange: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default InTransitRecoveryGlobalOverviewTable;
